exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".profile-edit[_v-810348a0]{top:0}.profile-edit .mdl-button.mdl-button--icon[_v-810348a0]{font-size:32px;width:48px;height:48px}.profile-edit .mdl-button.mdl-button--icon .material-icons[_v-810348a0]{color:#f19100;font-size:32px;left:20px;top:24px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-810348a0&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/client/pages/Profile.vue
// module id = 317
// module chunks = 0